import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const MyDocuments = lazy(() => import('../../container/investor/documents/Mydocuments'));
const DocumentsList = lazy(() => import('../../container/investor/documents/DocumentsList'));

function DocumentsRoute() {
  return (
    <Routes>
      <Route path="/" element={<MyDocuments />} />
      <Route path="all" element={<DocumentsList />} />
    </Routes>
  );
}

export default DocumentsRoute;
